import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/site";

export default function FloatingBar() {
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.6, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.6, ease: [0.22, 1, 0.36, 1] }}
            className="fixed bottom-6 right-6 z-40 flex flex-col gap-3"
        >
            <a
                href={CONTACT.phoneHref}
                data-testid="floating-phone-btn"
                aria-label="Bel direct"
                className="flex h-13 w-13 items-center justify-center rounded-full border border-line bg-white p-3.5 text-moss-800 shadow-lg transition-transform duration-200 hover:-translate-y-1 hover:text-terracotta"
            >
                <Phone size={20} />
            </a>
            <a
                href={CONTACT.whatsappUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="floating-whatsapp-btn"
                aria-label="WhatsApp ons"
                className="relative flex items-center justify-center rounded-full bg-[#25D366] p-3.5 text-white shadow-lg transition-transform duration-200 hover:-translate-y-1"
            >
                <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-25" />
                <MessageCircle size={22} />
            </a>
        </motion.div>
    );
}
